module.exports = __webpack_public_path__ + "static/assets/3f1628eabf2150b08370a646aac271a3.svg";